import type { NextPageContext } from 'next';
import cookies from 'nookies';
/* note: it would be nice to remove this for native node uuid, but we are still
calling this from the client in getInitialProps at times so its isomorphic */
import { v4 as uuidv4 } from 'uuid';

const doubleQuoteRegex = /"/g;
export const parseId = (str: string): string =>
    str.replace(doubleQuoteRegex, '');

export const ANON_ID_COOKIE_NAME = 'ajs_anonymous_id';

/**
 * Retrieve the anonId (ajs_anonymous_id cookie) from either client or server.
 *
 * If user has already visited the site and an anonId cookie is set then
 * read the cookie (from either request context for SSR or client document for
 * static pages)
 *
 * In some cases _middleware will generate a Set-Cookie header for anonid
 *
 * For a new user (i.e no ajs_anonymous_id yet) visiting a...
 * - SSR page: We should generate and Set-Cookie here so that value used during
 * SSR will match that picked up on client.
 * - static page: (at runtime with ISR, or prebuilt). There is
 * no ctx.res and therefore we do not get an anonId, instead _middleware will
 * Set-Cookie with a value for the client to pick up
 */
export function getAnonId(ctx: Pick<NextPageContext, 'req' | 'res'> | null) {
    const allCookies = cookies.get(ctx);
    const existingAnonId = allCookies[ANON_ID_COOKIE_NAME];

    if (existingAnonId) {
        return parseId(existingAnonId);
    }

    if (ctx?.res) {
        /* if ctx.res we must be in GetServerSideProps or GetInitialProps */

        /* ideally we could pull the value from the outgoing Set-Cookie header
        as set by _middleware, but this is not supported in vercel prod */
        const anonId = uuidv4();
        cookies.set(ctx, ANON_ID_COOKIE_NAME, anonId, {
            maxAge: 365 * 24 * 60 * 60,
            sameSite: 'lax'
        });
        return anonId;
    }

    /* no ctx.res, this function should only be called within data-fetching
    methods so we must be in GetStaticProps, in this case we can rely on
    _middleware having Set-Cookie and we will pick up on client render */
    return;
}
